var _defs, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tray",
    x1: 9,
    x2: 55,
    y1: 34,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22C55E",
    d: "M18 13h21l4 28H14l4-28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCFCE7",
    d: "M21 22h15v10H21z",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M20 13h17v6H20z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tray)",
    d: "M9 36h46l-5 17H14L9 36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBD5E1",
    d: "M15 38c5-3 29-3 34 0l-2 7H17l-2-7Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 41,
    r: 1.7,
    fill: "#94A3B8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 43,
    r: 1.5,
    fill: "#94A3B8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 41,
    r: 1.8,
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitter);
export default __webpack_public_path__ + "static/media/litter.5f0fb73dab6c3a4fe41a316226bd59ee.svg";
export { ForwardRef as ReactComponent };